/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SiteLookupResponseDto } from './SiteLookupResponseDto';
import {
    SiteLookupResponseDtoFromJSON,
    SiteLookupResponseDtoFromJSONTyped,
    SiteLookupResponseDtoToJSON,
    SiteLookupResponseDtoToJSONTyped,
} from './SiteLookupResponseDto';
import type { PaginationMetaDto } from './PaginationMetaDto';
import {
    PaginationMetaDtoFromJSON,
    PaginationMetaDtoFromJSONTyped,
    PaginationMetaDtoToJSON,
    PaginationMetaDtoToJSONTyped,
} from './PaginationMetaDto';

/**
 * 
 * @export
 * @interface ListSitesResponseDto
 */
export interface ListSitesResponseDto {
    /**
     * 
     * @type {Array<SiteLookupResponseDto>}
     * @memberof ListSitesResponseDto
     */
    data: Array<SiteLookupResponseDto>;
    /**
     * 
     * @type {PaginationMetaDto}
     * @memberof ListSitesResponseDto
     */
    meta: PaginationMetaDto;
}

/**
 * Check if a given object implements the ListSitesResponseDto interface.
 */
export function instanceOfListSitesResponseDto(value: object): value is ListSitesResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    return true;
}

export function ListSitesResponseDtoFromJSON(json: any): ListSitesResponseDto {
    return ListSitesResponseDtoFromJSONTyped(json, false);
}

export function ListSitesResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListSitesResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(SiteLookupResponseDtoFromJSON)),
        'meta': PaginationMetaDtoFromJSON(json['meta']),
    };
}

export function ListSitesResponseDtoToJSON(json: any): ListSitesResponseDto {
    return ListSitesResponseDtoToJSONTyped(json, false);
}

export function ListSitesResponseDtoToJSONTyped(value?: ListSitesResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(SiteLookupResponseDtoToJSON)),
        'meta': PaginationMetaDtoToJSON(value['meta']),
    };
}

